import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function Select({ options, value, onChange }) {
    const selectOnChange = selectValue => {
        onChange(selectValue);
    };

    const showLabel = showLabel => {
        if (showLabel) {
            return (
                <label
                    htmlFor={options.id + '-select-element'}
                    className="c-form-field__label"
                >
                    {options.text}
                </label>
            );
        }
    };

    const isRequired = isRequired => {
        if (isRequired) {
            return <span className="c-form-field__notion">*</span>;
        }
    };

    return (
        <Fragment>
            <div className={`c-form-field ${options?.classContainer || ''}`}>
                {showLabel(options.showLabel)}
                {isRequired(options.isRequired)}
                <div className="c-form-field__box">
                    <div className="c-input  c-input--select">
                        <select
                            value={value}
                            disabled={options.disabled}
                            onChange={e => selectOnChange(e.target.value)}
                            className={'c-input__input ' + options.className}
                            name={options.name + '-select-element'}
                            id={options.id + '-select-element'}
                            data-testid={options.id + '-select-element'}
                        >
                            {options.values &&
                                options.values.map((valueOption, index) => {
                                    return (
                                        <option
                                            key={index}
                                            value={valueOption.value}
                                        >
                                            {valueOption.text}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

Select.propTypes = {
    options: PropTypes.shape({
        name: PropTypes.string,
        text: PropTypes.string,
        id: PropTypes.string,
        className: PropTypes.string,
        classContainer: PropTypes.string,
        disabled: PropTypes.bool,
        values: PropTypes.array,
        showLabel: PropTypes.bool.isRequired,
        isRequired: PropTypes.bool,
    }).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default Select;
